import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const GlobalStyle = createGlobalStyle`
	${reset}
  * { padding: 0; margin: 0; }

  
  /** Mozilla scrollbar*/
  * {
    scrollbar-color: #CCC !important;
    scrollbar-width: thin !important;
  }
  /** Scrollbar for browser based on webkit */
  ::-webkit-scrollbar {
    width: 6px;
    height: 0px;
  }
  ::-webkit-scrollbar-thumb {
    background: #CCCCCC;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #AFAFAF;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #6b6b6b;
  }
  ::-webkit-scrollbar-track {
    background: rgba(204, 204, 204, 0.3);
  }
  
  html, #root{
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
    background: ${({ theme }) => theme.bgColor};
  }
	body{
		background: ${({ theme }) => theme.bgColor};
    color: ${({ theme }) => theme.textColor};
    width: 100%;
    height: 100%;
    margin: 0;
    transition: .2s all ease;
	}
  .w-100{
    width:100%!important;
  }
  .h-100{
    height: 100%!important;
  }
  .pl-2{
    padding-left: 12px!important;
  }
  .pl-3{
    padding-left: 16px!important;
  }
  .text-center{
    text-align:center!important;
  }
  .round-5{
    border-radius: 20px;
  }

  .text-decoration-none{
    text-decoration: none;
  }

  .sale-time{
    display: flex;
  }

  main.main-container{
    margin-top: 107px;
    height: calc(100% - 107px);
    overflow: auto;
  }

  span.th-chip-span{
    text-transform: capitalize;
    background: #F46B6B;
    border-radius: 5px;
    padding: 2px;
    font-size: 9px;
  }

  span.td-first-col-span{
    color: ${({ theme }) => theme.textColor};
  }

  span.down-rate-span{
    color: ${({ theme }) => theme.errorColor};
    font-size: 12px;
  }

  span.up-rate-span{
    color: ${({ theme }) => theme.successColor};
    font-size: 12px;
  }
  
  @media only screen and (max-width: 900px){
    main.main-container{
      margin-top: 154px;
      height: calc(100% - 154px);
    }
  }
  
  
  .app-bar, .footer-bar, roadmap-section{
    background: ${({ theme }) => theme.bgColor};
    background-color: ${({ theme }) => theme.bgColor};
    color: ${({ theme }) => theme.textColor};
  }
  main.layout-content{
    // height: calc(100vh - 90px);
    margin-top: 90px;
    overflow: auto;
    background: ${({ theme }) => theme.mainPageBg};
  }
  .primaryBg{
    background: ${({ theme }) => theme.bgColor};
  }
  .primaryFontColor{
    color: ${({ theme }) => theme.textColor};
  }
  .logo-img{
    width: 30px;
    height: 70px;
  }
  .logo-alone-img{
    width: 100px;
  }
  .nav-link{
    color: ${({ theme }) => theme.textColor};
    text-decoration: none;
    margin-right: 10px;
    font-weight: bold;
  }
  .nav-link-three-dot{
    color: ${({ theme }) => theme.textColor};
  }

  
  .back2top-btn {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 1000;
    width: 50px;
    height: 50px;
    display:flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.phaseCardShadowColor};
    border-radius: 50%;
    -webkit-animation: wang 2s infinite;
    animation: wang 2s infinite;
    transition: all linear 0.3s;
    -webkit-transition: all linear 0.3s;
    -moz-transition: all linear 0.3s;
    -ms-transition: all linear 0.3s;
    -o-transition: all linear 0.3s;
  }

  .back2top-btn-con{
      
      // box-shadow: 0px 0px 4px 4px rgb(180, 180, 180);
  }

  .menu-select-bar{
    width: 0;
    height: 1px;
    background: ${({ theme }) => theme.textColor};
    margin-right: 10px;
  }
  .menu-select-bar.selected{
    animation-fill-mode: forwards;  
    animation: selectmenu 0.5s ease-in-out forwards;
    width: 30px;
  }

  .nav-item-con{
    text-decoration: none;
    color: ${({ theme }) => theme.textColor};
  }

  .btn{
    cursor: pointer;
    text-decoration: none;
  }

  .btn-pink-gradient{
    background-image: linear-gradient(273.19deg, #d77e7e 4.57%, #f86969 95.62%);
    border-radius: 30px;
  }

  .btn-purple-gradient{
    border-radius: 30px;
    background-color: rgba(115, 137, 218, 1);
  }

  .nav-item-con:hover{
    background: ${({ theme }) => theme.hoverColor};
  }

  .discord-logo-btn{
    height:1.5rem 
  }

  .search-input{
    width: 100%;
    height: 100%;
    background: transparent;
    box-shadow: none;
    border: 1px solid gray;
    padding: 2px 26px 2px 18px;
    border-radius: 30px;
    color: ${({ theme }) => theme.disabledTextColor};
    font-size: 18px;
  }

  @media only screen and (max-width: 900px){
    .search-input{
      padding: 12px 26px 12px 18px;
    }
  }

  .search-input:focus-visible{
    outline: none;
  }

  .search-input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: ${({ theme }) => theme.disabledTextColor};
    /* font-weight: bold; */
  }
  .search-input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: ${({ theme }) => theme.disabledTextColor};
    font-weight: bold;
    opacity: 1;
  }
  .search-input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: ${({ theme }) => theme.disabledTextColor};
    font-weight: bold;
    opacity: 1;
  }
  .search-input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ theme }) => theme.disabledTextColor};
    font-weight: bold;
  }

  @-webkit-keyframes selectmenu {
    0% {
      width: 0px;
    }
    100% {
      width: 30px;
    }
  }

  @keyframes selectmenu {
    0% {
      width: 0px;
    }
    100% {
      width: 30px;
    }
  }

  .phase-card{
    box-shadow: 0px 0px 30px 10px ${({ theme }) => theme.phaseCardShadowColor};
    background: ${({ theme }) => theme.bgColor};
  }

  @media only screen and (max-width: 768px){
    
  }

  @media only screen and (max-width: 500px){
    
  }

  @media only screen and (max-width: 600px){
    main.layout-content{
      // height: calc(100vh - 90px);
      overflow: auto
    } 
  }
  
  
  
  

  .container{
    // width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding: 12px;
  }


  @media only screen and (min-width: 1400px){
    .container{
      max-width: 1320px;
    }
  }
  @media only screen and (min-width: 1200px) and (max-width: 1400px){
    .container{
      max-width: 1140px;
    }
  }
  @media only screen and (min-width: 992px) and (max-width: 1200px){
    .container{
      max-width: 960px;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 992px){
    .container{
      max-width: 720px;
    }
  }
  @media only screen and (min-width: 576px) and (max-width: 768px){
    .container{
      max-width: 540px;
    }
  }
  @media only screen and (max-width: 576px){
    .container{
      max-width: 100%;
    }
  }


`;
